import { render } from "./PimProductsDetailLab.vue?vue&type=template&id=59708cd4&scoped=true&ts=true"
import script from "./PimProductsDetailLab.vue?vue&type=script&lang=ts"
export * from "./PimProductsDetailLab.vue?vue&type=script&lang=ts"

import "./PimProductsDetailLab.vue?vue&type=style&index=0&id=59708cd4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59708cd4"]])

export default __exports__